
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 59 57\" id=\"star_icon_jax_87d5daa7f9309ea1dfe308cea53765b5\" > <path d=\"M29.4998 5.10156L37.7369 20.2053L54.6468 23.372L42.8277 35.8732L45.0415 52.9341L29.4998 45.5565L13.958 52.9341L16.1718 35.8732L4.35272 23.372L21.2626 20.2053L29.4998 5.10156Z\" fill=\"#2CD4AE\" stroke=\"white\" stroke-width=\"4.06787\"/> </symbol>";
module.exports = sprite.add(image, "star_icon_jax_87d5daa7f9309ea1dfe308cea53765b5");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star_icon.svg
// module id = 1766
// module chunks = 1